import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    exportLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: [],
    countryList: [],
    companyList: [],
    gameList: [],
    gameRule: [],
    featuredImage: {},
    featuredImage2: {},
    listLoading: false,
    contestItem: null,
    frontLoading: false
}

export const callTypes = {
    list: "list",
    action: "action"
};

export const NewAddContestSlice = createSlice({
    name: "newAddContests",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            state.rulesLoading = false;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        endCall: (state, action) => {
            state.error = null;
            state.rulesLoading = false;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        countryList: (state, action) => {
            const { countryList } = action.payload;
            state.listLoading = false;
            state.frontLoading = false;
            state.error = null;
            state.countryList = countryList;
        },
        companyList: (state, action) => {
            const { companyList } = action.payload;
            state.listLoading = false;
            state.frontLoading = false;
            state.error = null;
            state.companyList = companyList;
        },
        gameList: (state, action) => {
            const { gameList } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.gameList = gameList;
        },
        gameRule: (state, action) => {
            const { gameRule } = action.payload;
            state.listLoading = false;
            state.rulesLoading = false;
            state.error = null;
            state.gameRule = gameRule;
        },
        imageUploaded: (state, action) => {
            const { entities, imageField } = action.payload;
            state.error = null;
            state[imageField] = entities;
        },
        ruleLoader: (state, action) => {
            state.error = null;
            state.rulesLoading = true;
            state.gameRule = null;
        },
        contestItem: (state, action) => {
            const { contestItem } = action.payload;
            state.error = null;
            state.contestItem = contestItem;
        },
        frontLoader: (state, action) => {
            state.error = null;
            state.frontLoading = true;
            state.gameRule = null;
        },
    }
})